/**
 * storage.js — Sprint 1.5b
 *
 * NON salva piu' la mnemonica in chiaro in localStorage.
 * Salva solo identificatori pubblici/non-sensibili (sigil, uid).
 */

const LS_KEY = 'nullum.session.v2';
const LEGACY_KEYS = ['nullum.session', 'nullum.mnemonic', 'nullum.sigil'];

/**
 * Salva info di sessione NON sensibili. La mnemonica viene IGNORATA
 * anche se passata (per retro-compatibilita' col call site vecchio).
 *
 * @param {object} session
 * @param {string} [session.sigil]
 * @param {string} [session.uid]
 */
export function saveSession(session) {
  try {
    const safe = {
      sigil: session?.sigil || null,
      uid: session?.uid || null,
      ts: Date.now(),
    };
    localStorage.setItem(LS_KEY, JSON.stringify(safe));
  } catch (e) {
    console.warn('saveSession', e);
  }
}

export function loadSession() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return {};
    const obj = JSON.parse(raw);
    return obj && typeof obj === 'object' ? obj : {};
  } catch {
    return {};
  }
}

export function clearSession() {
  try {
    localStorage.removeItem(LS_KEY);
    // Pulisce anche eventuali residui di vecchie versioni
    for (const k of LEGACY_KEYS) {
      try { localStorage.removeItem(k); } catch {}
    }
  } catch {}
}
